import {bindUploaderConfig} from './wp-media-uploader.js';

function normalizeMode(value) {
    const v = String(value || '').trim().toLowerCase();
    return v === 'upload' ? 'upload' : 'browse';
}

let mediaAjaxPatched = false;

function isAttachmentQueryRequest(options) {
    return options?.data?.action === 'query-attachments';
}

function shouldNormalizeAttachmentQueryResult(payload) {
    return payload === false || payload == null || payload === '';
}

function patchMediaAjax() {
    if (mediaAjaxPatched || !wp?.media?.ajax || !window?.jQuery?.Deferred) {
        return;
    }

    const originalMediaAjax = wp.media.ajax.bind(wp.media);

    wp.media.ajax = function (options) {
        const request = originalMediaAjax(options);

        if (!isAttachmentQueryRequest(options) || !request?.done || !request?.fail) {
            return request;
        }

        const deferred = window.jQuery.Deferred();

        request.done(function (payload) {
            if (shouldNormalizeAttachmentQueryResult(payload)) {
                deferred.resolveWith(this, [[]]);
                return;
            }

            deferred.resolveWith(this, [payload]);
        });

        request.fail(function () {
            if (shouldNormalizeAttachmentQueryResult(arguments[0])) {
                deferred.resolveWith(this, [[]]);
                return;
            }

            deferred.rejectWith(this, arguments);
        });

        const promise = deferred.promise();

        if (typeof request.abort === 'function') {
            promise.abort = function () {
                request.abort();
                return promise;
            };
        }

        return promise;
    };

    mediaAjaxPatched = true;
}

export function createMediaFrame({multiple, config, getCurrentValue, initialState}) {
    patchMediaAjax();

    const mode = normalizeMode(initialState);

    const mediaFrame = wp.media({
        title: multiple ? 'Vyberte fotky' : 'Vyberte obrázek',
        button: {text: multiple ? 'Vybrat fotky' : 'Vybrat obrázek'},
        frame: 'select',
        multiple,
        library: config.library ?? {},
        state: mode === 'upload' ? 'library' : 'library',
    });

    mediaFrame.on('open', function () {
        if (mode === 'upload') {
            mediaFrame.setState('library');
            if (mediaFrame.content) {
                mediaFrame.content.mode('upload');
            }
        } else {
            mediaFrame.setState('library');
            if (mediaFrame.content) {
                mediaFrame.content.mode('browse');
            }
        }

        const selection = mediaFrame.state().get('selection');
        selection.reset();

        getCurrentValue()
            .toString()
            .split(',')
            .map(id => parseInt(id.trim(), 10))
            .filter(id => id > 0)
            .forEach(id => {
                const attachment = wp.media.attachment(id);
                attachment.fetch();
                selection.add(attachment);
            });
    });

    bindUploaderConfig(mediaFrame, config.uploader);

    return mediaFrame;
}
